import React from 'react';
import Spinner from '../../styles/images/spinner.gif';
import './style.scss';

export const ImageLoader = ({ src, alt, ...props }) => {
  const [loaded, setLoaded] = React.useState(false);
  React.useEffect(() => {
    if (!src) return;
    setLoaded(false);
    const img = new Image();
    img.src = src;
    img.onload = () => setLoaded(true);
    img.onerror = () => setLoaded(true);
  }, [src]);

  if (!src) {
    return <div {...props} className="image-placeholder__placeholder" />;
  }

  return loaded ? (
    <img alt={alt} src={src} {...props} />
  ) : (
    <div className="image-placeholder">
      <img src={Spinner} alt="" className="gifSpinner" />
    </div>
  );
};
